/* Optional presentation only. Shopify's rendered cart remains the source of every value. */
(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Set();
  const closing = new Map();
  const ease = 'cubic-bezier(0.22, 1, 0.36, 1)';

  function animate(node, frames, duration = 280) {
    if (!node?.animate || reduced.matches || document.hidden || !node.getClientRects().length) return null;
    // Repeated section updates replace the prior effect instead of accumulating animations.
    for (const previous of active) {
      if (previous.effect?.target === node) previous.cancel();
    }
    try {
      const animation = node.animate(frames, { duration, easing: ease });
      active.add(animation);
      animation.finished.then(() => active.delete(animation), () => active.delete(animation));
      return animation;
    } catch { return null; } // An optional effect must never interrupt cart rendering.
  }

  function captureCart() {
    const dock = $('[data-bundle-dock]');
    const progress = $('[data-bundle-tier]', dock || document);
    const meter = $('.meter i', dock || document);
    const drawer = $('[data-cart-drawer]');
    return {
      count: $('[data-cart-count]')?.textContent.trim(),
      tier: Number(progress?.dataset.bundleTier || 0),
      // Capture the visible intermediate scale if another response interrupts the meter.
      meter: meter ? getComputedStyle(meter).transform : null,
      thumbs: new Set($$('[data-bundle-product]', dock || document).map(el => el.dataset.bundleProduct)),
      lines: new Map(drawer?.open ? $$('[data-line-key]', drawer).map(el => [el.dataset.lineKey, el.getBoundingClientRect().top]) : []),
      drawerOpen: Boolean(drawer?.open),
      scroll: $('.drawer__body', drawer || document)?.scrollTop || 0,
    };
  }

  function updateCart(before) {
    if (!before) return;
    const dock = $('[data-bundle-dock]');
    const progress = $('[data-bundle-tier]', dock || document);
    const meter = $('.meter i', dock || document);
    const drawer = $('[data-cart-drawer]');
    // Keep the user's position when Shopify replaces the drawer contents.
    const body = $('.drawer__body', drawer || document);
    if (before.drawerOpen && body) body.scrollTop = before.scroll;
    $$('[data-cart-count]').forEach(count => {
      if (count.textContent.trim() !== before.count && !count.hidden) {
        animate(count, [{ opacity: 0.4, transform: 'translateY(3px)' }, { opacity: 1, transform: 'translateY(0)' }], 180);
      }
    });
    $$('[data-bundle-product]', dock || document).forEach(thumb => {
      if (!before.thumbs.has(thumb.dataset.bundleProduct)) {
        animate(thumb, [{ opacity: 0, transform: 'translateY(5px) scale(0.96)' }, { opacity: 1, transform: 'none' }]);
      }
    });
    if (meter && before.meter && before.meter !== 'none') {
      const target = getComputedStyle(meter).transform;
      if (target !== before.meter) animate(meter, [{ transform: before.meter }, { transform: target }], 320);
    }
    if (Number(progress?.dataset.bundleTier || 0) > before.tier) {
      const summary = $('.dock__text > span', dock);
      animate(summary, [{ opacity: 0.5 }, { opacity: 1 }], 320);
    }
    if (before.drawerOpen && drawer?.open) {
      $$('[data-line-key]', drawer).forEach(line => {
        const oldTop = before.lines.get(line.dataset.lineKey);
        if (oldTop === undefined) {
          animate(line, [{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }]);
        } else {
          const delta = Math.max(-12, Math.min(12, oldTop - line.getBoundingClientRect().top));
          if (Math.abs(delta) > 1) animate(line, [{ transform: `translateY(${delta}px)` }, { transform: 'none' }]);
        }
      });
    }
  }

  function openDrawer(drawer) {
    const animation = closing.get(drawer);
    closing.delete(drawer);
    delete drawer.dataset.closing;
    animation?.cancel();
  }

  function closeDrawer(drawer) {
    if (!drawer?.open || closing.has(drawer)) return;
    // Start from the current position if Escape interrupts the entrance animation.
    const animation = animate(drawer, [
      { transform: getComputedStyle(drawer).transform }, { transform: 'translateX(100%)' },
    ], 180);
    if (!animation) { drawer.close(); return; }
    drawer.dataset.closing = 'true';
    closing.set(drawer, animation);
    const finish = () => {
      if (closing.get(drawer) !== animation) return;
      closing.delete(drawer);
      delete drawer.dataset.closing;
      if (drawer.open) drawer.close();
    };
    animation.finished.then(finish, finish);
  }

  document.addEventListener('cancel', event => {
    if (!event.target.matches?.('[data-cart-drawer]')) return;
    event.preventDefault();
    closeDrawer(event.target);
  }, true);
  document.addEventListener('close', event => {
    if (event.target.matches?.('[data-cart-drawer]')) openDrawer(event.target);
  }, true);
  const stop = () => {
    for (const animation of active) animation.cancel();
    active.clear();
    // Complete pending closes immediately when motion is disabled or the tab is hidden.
    for (const drawer of closing.keys()) {
      closing.delete(drawer);
      delete drawer.dataset.closing;
      if (drawer.open) drawer.close();
    }
  };
  reduced.addEventListener('change', () => { if (reduced.matches) stop(); });
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
  window.PM3DMotion = { captureCart, updateCart, openDrawer, closeDrawer };
})();
